import { Params } from '@angular/router';
export interface StepNavPropsModel {
  stepCode: string;
  path: string;
  fullPath: string;
  params?: Params;
}
